import { ArrowLeft01Icon, ArrowRight01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { ReactNode, createElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import { useAppDispatch } from '@/hooks';
import { addOrganization } from '../slice';
import { RootState } from '@/store/store';
import Details from './steps/Details';
import Industry from './steps/Industry';

const steps = [
  {
    title: 'Detalles',
    component: Details,
  },
  {
    title: 'Industria',
    component: Industry,
  },
];

const NewOrganization = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set<number>());
  const user = useSelector((state: RootState) => state.auth.user);
  const { organizationId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Container sx={{ width: '100%', marginTop: 4 }}>
      <Paper sx={{ padding: 4 }}>
        <Typography variant="h1">Nueva Organización</Typography>
        <Stepper activeStep={activeStep}>
          {steps.map(({ title }, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: ReactNode;
            } = {};

            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={title} {...stepProps}>
                <StepLabel {...labelProps}>{title}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <Formik
          initialValues={{
            id: '',
            title: '',
            createdBy: user?.uid ?? '',
            createdAt: undefined,
          }}
          onSubmit={async (values) => {
            const response = await dispatch(addOrganization(values));
            if (response.meta.requestStatus === 'fulfilled') {
              navigate(`/comercios/${organizationId}/menus`);
            }
          }}
        >
          {({ handleSubmit }) => (
            <Form>
              <Box sx={{ paddingY: 4 }}>
                {createElement(steps[activeStep].component)}
              </Box>
              <Stack direction={'row'} spacing={2} justifyContent={'center'}>
                <Button
                  color="inherit"
                  disabled={activeStep === 0}
                  startIcon={<HugeiconsIcon icon={ArrowLeft01Icon} />}
                  onClick={handleBack}
                >
                  Regresar
                </Button>
                <Button
                  endIcon={<HugeiconsIcon icon={ArrowRight01Icon} />}
                  onClick={
                    activeStep === steps.length - 1 ? handleSubmit : handleNext
                  }
                >
                  {activeStep === steps.length - 1 ? 'Finalizar' : 'Continuar'}
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      </Paper>
    </Container>
  );
};

export default NewOrganization;
